<template>
  <Modal v-model="billUpdateCompletedModal" :title="modalTitle" width="700"
    :transfer="false" :mask-closable="false" @on-visible-change="billUpdateCompletedChange">
    <div class="flex">
      <!-- 客户账单内容 -->
      <template v-if="isCustomerBill">
        <span>{{ $t('key1000497') }}</span>
        <span class="themeColor">{{ businessMerchantName }}</span>
        <span>{{ $t('key1000498') }}</span>
        <span class="themeColor">{{ billMonth }}</span>
        <span>”</span>
      </template>
      <!-- 公共文案（统一放这里） -->
      <span>{{ $t('key1000499') }}</span>
    </div>
    <template #footer>
      <Button @click="billUpdateCompletedModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="billUpdateCompletedBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {commonLocalStorage, EventBus} from '@/utils/common';

export default {
  name: 'billUpdateCompletedModal',
  mixins: [Mixin],
  data() {
    return {
      billUpdateCompletedModal: false,
      businessMerchantName: '',
      billMonth: '',
      details: {},
      webSocketListenerKey: '',
      billTypeConfig: {
        3: {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000494'),
          path: '/customerBill',
          localStorageKey: 'customerBillQuery',
          eventName: 'initCustomerBillUpdateCompletedData'
        },
        7: {
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000495'),
          path: '/platformBill',
          localStorageKey: 'platformBillQuery',
          eventName: 'initPlatformBillUpdateCompletedData'
        }
      }
    };
  },

  computed: {
    // 当前登录用户信息
    userInfo() {
      return this.$store.state.erpConfig ? this.$store.state.erpConfig.userInfo : {};
    },
    // 当前账单类型
    billType() {
      return this.details.billType;
    },
    // 当前账单配置
    billConfig() {
      return this.billTypeConfig[this.billType] || {};
    },
    // 账单名称
    billName() {
      return this.billConfig.name || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000496');
    },
    // 弹窗标题
    modalTitle() {
      return `${this.billName}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000491')}`;
    },
    // 是否为客户账单
    isCustomerBill() {
      return this.billType === 3;
    }
  },
  created() {
    this.initWebSocket();
  },
  beforeDestroy() {
    this.clearWebSocketListener();
  },
  methods: {
    /**
     * @Description: 初始化 websocket 监听（账单更新完成通知）
     * 监听服务端推送 → 判断用户 → 弹出提示框
     */
    initWebSocket() {
      let v = this;
      // 未初始化 websocket 直接返回
      if (!v.$webSocket.initWebSocket()) {
        return;
      }
      // 生成唯一监听 key（避免冲突）
      v.webSocketListenerKey = `bill-updateCompleted-${v._uid}`;
      v.$webSocket.subscribeMessage(v.webSocketListenerKey, (e) => {
        const data = v.$webSocket.parseMessage(e);
        // 基础校验
        if (!data || data.type !== 'sync' || v.system !== 'yms') {
          return;
        }
        const obj = data.data || {};
        // 非支持的账单类型直接忽略
        if (!v.billTypeConfig[obj.billType]) {
          return;
        }
        // 非当前用户不弹窗
        if (obj.toUser !== v.userInfo.userId) {
          return;
        }
        v.details = obj;
        v.businessMerchantName = obj.businessMerchantName || '';
        v.billMonth = v.formatBillMonth(obj.billMonth);
        v.billUpdateCompletedModal = true;
      });
    },

    /**
     * @Description: 格式化账单月份
     * @param {String} billMonth 格式：2026-04
     * @return {String} 格式：2026年04月
     */
    formatBillMonth(billMonth) {
      if (!billMonth) {
        return '';
      }
      const time = billMonth.split('-');
      if (time.length < 2) {
        return billMonth;
      }
      return `${time[0]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000492')}${time[1]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000493')}`;
    },

    /**
     * @Description: 清除 websocket 监听（防止内存泄漏）
     */
    clearWebSocketListener() {
      if (!this.webSocketListenerKey) {
        return;
      }
      this.$webSocket.unsubscribeMessage(this.webSocketListenerKey);
      this.webSocketListenerKey = '';
    },
    // 确定
    billUpdateCompletedBtn() {
      let v = this;
      const config = v.billConfig;
      if (!config.path) {
        v.billUpdateCompletedModal = false;
        return;
      }
      // 已在当前页面 → 直接刷新
      if (v.$route.path === config.path) {
        EventBus.$emit(config.eventName, v.details);
        v.billUpdateCompletedModal = false;
        return;
      }
      // 生成跳转地址
      const {href} = v.$router.resolve({
        path: config.path
      });
      // 缓存参数（新页面读取）
      commonLocalStorage.setItem(config.localStorageKey, v.details);
      setTimeout(() => {
        v.billUpdateCompletedModal = false;
        window.open(href, '_blank');
      }, 800);
    },

    // 监听弹窗
    billUpdateCompletedChange(value) {
      if (!value) {
        this.businessMerchantName = '';
        this.billMonth = '';
        this.details = {};
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>